import { Button, Card, Table, Title } from '@mantine/core';
import { t } from 'i18next';
import { useState } from 'react';

import { Number, TableDataCell, TableHeaderCell, ToggleButton } from 'components';
import { useScenarioContext } from 'providers/ScenarioProvider';

const OutputTable = () => {
    const scenarios = useScenarioContext();
    return (
        <Table>
            <Table.Thead>
                <Table.Tr>
                    <TableHeaderCell >
                        {t('scenario')}
                    </TableHeaderCell>
                    <TableHeaderCell >
                        {t('recommendedTemperature')}
                    </TableHeaderCell >

                    <TableHeaderCell />

                    <TableHeaderCell indent={true} subLabel={t('co2Footprint')}>
                        {t('concrete')}
                    </TableHeaderCell >
                    <TableHeaderCell subLabel={t('costs')} />

                    <TableHeaderCell />

                    <TableHeaderCell indent={true} subLabel={t('consumption')}>
                        {t('electricity')}
                    </TableHeaderCell >
                    <TableHeaderCell subLabel={t('co2Footprint')} />
                    <TableHeaderCell subLabel={t('costs')} />

                    <TableHeaderCell />

                    <TableHeaderCell indent={true} subLabel={t('co2Footprint')}>
                        {t('total')}
                    </TableHeaderCell >
                    <TableHeaderCell indent={true} subLabel={t('costs')} />
                </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
                {scenarios.map((scenario, index) => {
                    const { forecast, summary } = scenario;
                    if (forecast && summary) {
                        return (
                            <Table.Tr key={index}>
                                <TableDataCell bold={true}>
                                    {`Scenario ${index + 1}`}
                                </TableDataCell>
                                <TableDataCell bold={true}>
                                    <Number decimalScale={0} unit="°C">{forecast.recommendedTemperature}</Number>
                                </TableDataCell>

                                <TableDataCell />

                                <TableDataCell indent={true} >
                                    <Number decimalScale={0} unit="kg CO₂">{forecast.co2Concrete}</Number>
                                </TableDataCell>
                                <TableDataCell>
                                    <Number decimalScale={0} unit="€">{forecast.concreteCosts}</Number>
                                </TableDataCell>

                                <TableDataCell />

                                <TableDataCell indent={true} >
                                    <Number decimalScale={0} unit="kWh">{forecast.electricityConsumption}</Number>
                                </TableDataCell>
                                <TableDataCell>
                                    <Number decimalScale={0} unit="kg CO₂">{forecast.co2Electricity}</Number>
                                </TableDataCell>
                                <TableDataCell>
                                    <Number decimalScale={0} unit="€">{forecast.electricityCosts}</Number>
                                </TableDataCell>

                                <TableDataCell />

                                <TableDataCell recommended={summary.co2Recommended} summary={true}>
                                    <Number decimalScale={0} unit="kg CO₂">{summary.co2Total}</Number>
                                </TableDataCell>
                                <TableDataCell recommended={summary.costsRecommended} summary={true}>
                                    <Number decimalScale={0} unit="€">{summary.costsTotal}</Number>
                                </TableDataCell>
                            </Table.Tr>
                        );
                    }
                })}
            </Table.Tbody>
        </Table>
    );
};

const InputTable = () => {
    const scenarios = useScenarioContext();
    return (
        <Table>
            <Table.Thead>
                <Table.Tr>
                    <TableHeaderCell >
                        {t('scenario')}
                    </TableHeaderCell>
                    <TableHeaderCell >
                        {t('ambientTemperature')}
                    </TableHeaderCell>
                    <TableHeaderCell >
                        {t('freshConcreteTemperature')}
                    </TableHeaderCell >

                    <TableHeaderCell>
                        {t('concreteMixture')}
                    </TableHeaderCell >
                    <TableHeaderCell>
                        {t('calibrationCurve')}
                    </TableHeaderCell>

                    <TableHeaderCell>
                        {t('concretePrice')}
                    </TableHeaderCell >
                </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
                {scenarios.map((scenario, index) => {
                    return (
                        <Table.Tr key={index}>
                            <TableDataCell bold={true}>
                                {`Scenario ${index + 1}`}
                            </TableDataCell>
                            <TableDataCell>
                                <Number unit="°C">{scenario.ambientTemperature}</Number>
                            </TableDataCell>
                            <TableDataCell>
                                <Number unit="°C">{scenario.freshConcreteTemperature}</Number>
                            </TableDataCell>

                            <TableDataCell>
                                {scenario.concreteMixture?.name}
                            </TableDataCell>
                            <TableDataCell>
                                {scenario.calibrationCurve?.name}
                            </TableDataCell>

                            <TableDataCell>
                                <Number unit="€/m³">{scenario.concretePrice}</Number>
                            </TableDataCell>
                        </Table.Tr>
                    );
                })}
            </Table.Tbody>
        </Table>
    );
};

export const ForecastTable = () => {
    const [showInput, setShowInput] = useState<boolean>(false);

    return (
        <Card className="flex flex-col gap-lg p-6 w-full">
            <div className="flex justify-between w-full">
                <Title order={4}>{t('scenarios')}</Title>
                <Button.Group>
                    <ToggleButton
                        selected={!showInput} onClick={() => setShowInput(false)}>
                        {t('output')}
                    </ToggleButton>
                    <ToggleButton
                        selected={showInput} onClick={() => setShowInput(true)}>
                        {t('input')}
                    </ToggleButton>
                </Button.Group>
            </div>
            {showInput ?
                <InputTable /> :
                <OutputTable />
            }
        </Card >
    );
};
